import React from 'react'

/**
 * Tells descendant field shells to paint `is required` errors before the entity is submitted.
 * Sections flip it true on a blocked advance (submit-mode) or on becoming active (automatic-mode).
 * Default false — shells otherwise wait for the parent entity's hasSubmitted.
 */
export const UI2FormSectionSubmitContext = React.createContext<boolean>(false)
